(() => {
  const popup = document.querySelector('[data-hp-newsletter-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;

  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const isHomepage = popup.dataset.hpPageType === 'index';
  const storageKey = isMobile ? 'hp_newsletter_popup_mobile_seen_v1' : 'hp_newsletter_popup_seen_v1';
  const success = popup.querySelector('[data-hp-popup-success]');
  let seen = false;
  try { seen = localStorage.getItem(storageKey) === '1'; } catch (_) {}

  function showPopup() {
    if (popup.open) return;
    popup.showModal();
    popup.focus({ preventScroll: true });
    try { localStorage.setItem(storageKey, '1'); } catch (_) {}
  }

  if (success) showPopup();
  else if (!seen) setTimeout(showPopup, isMobile ? 5000 : isHomepage ? 5000 : 30000);

  popup.querySelector('[data-hp-popup-close]').addEventListener('click', () => popup.close());
  popup.addEventListener('click', (event) => {
    if (event.target === popup) popup.close();
  });
})();
